import React from 'react';

import { css } from '@emotion/css';
import { colors } from 'theme/colors';

import { FlexSpace } from 'components/FlexSpace';
import { Typography } from 'components/Typography';
import { StyledTypography } from 'components/Typography/Typography.style';

import { formatDate } from 'utils/formatting';

import { ExpandableTextBlock } from './sidePane/ExpandableTextBlock';
import { WarningIconTooltip } from './sidePane/WarningIconTooltip';

interface NoteProps {
  note: string;
  topic: string;
  updatedAt: string;
  isCritical: boolean;
}

export function NotesHeaderSection({ notes }: { notes: NoteProps[] }) {
  if (notes.length === 0) {
    return (
      <StyledTypography
        type="small"
        className={css`
          text-align: left;
          color: ${colors.neutral[400]};
        `}
      >
        No notes were found for this vendor
      </StyledTypography>
    );
  }
  return (
    <div
      className={css`
        width: 100%;
      `}
    >
      <ul
        className={css`
          width: 100%;
          padding-left: 0px;
          padding-top: 0px;
          list-style: none;
        `}
      >
        {notes.map((note, lineNoteIdx) => (
          <li
            key={`_${lineNoteIdx}`}
            className={css`
              padding-bottom: 16px;
            `}
          >
            <FlexSpace direction="row" gap={8} alignItems="center" justify="space-between">
              <span
                className={css`
                  display: inline-flex;
                  align-items: center;
                `}
              >
                <Typography style={{ fontWeight: 500 }} type="subtitle">
                  {note.topic}
                </Typography>
                {note.isCritical && (
                  <span
                    className={css`
                      transform: scale(0.7);
                      display: inline-flex;
                    `}
                  >
                    <WarningIconTooltip tooltipText="Vendor or Supplier Note marked as critical" wrapText />
                  </span>
                )}
              </span>
              <span>
                <Typography type="extrasmall" style={{ color: colors.neutral[400], marginRight: 8 }}>
                  {formatDate(note.updatedAt)}
                </Typography>
              </span>
            </FlexSpace>
            <ExpandableTextBlock text={note.note} />
          </li>
        ))}
      </ul>
    </div>
  );
}
